






















import Vue from "vue";
export default Vue.extend({
  name: "file-list",
  props: {
    label: {
      type: String,
      required: false,
    },
    files: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    async downloadFile(file) {
      var fileData = window.URL.createObjectURL(file.data);
      var fileLink = document.createElement("a");
      fileLink.href = fileData;
      fileLink.setAttribute("download", file.bestandsnaam);
      document.body.appendChild(fileLink);
      fileLink.click();
    },
  },
});
